(function () {
  if (window.CartShareFeatureInitialized) return;
  window.CartShareFeatureInitialized = true;

  const selectors = {
    root: '[data-cart-share]',
    copy: '[data-cart-share-copy]',
    whatsapp: '[data-cart-share-whatsapp]',
    email: '[data-cart-share-email]',
    message: '[data-cart-share-message]'
  };

  function getLocaleRoot() {
    if (window.Shopify && Shopify.routes && Shopify.routes.root) {
      return Shopify.routes.root.replace(/\/$/, '');
    }
    return '';
  }

  async function fetchCart() {
    const response = await fetch(`${getLocaleRoot()}/cart.js`, {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    });

    if (!response.ok) {
      throw new Error('Unable to fetch cart');
    }

    return response.json();
  }

  function buildCartPath(cart) {
    if (!cart || !Array.isArray(cart.items) || !cart.items.length) {
      return `${getLocaleRoot()}/cart`;
    }

    const visibleItems = cart.items.filter((item) => {
      return item && item.variant_id && item.quantity > 0;
    });

    if (!visibleItems.length) {
      return `${getLocaleRoot()}/cart`;
    }

    const permalinkItems = visibleItems
      .map((item) => `${item.variant_id}:${item.quantity}`)
      .join(',');

    return `${getLocaleRoot()}/cart/${permalinkItems}?storefront=true`;
  }

  async function buildShareUrl() {
    const cart = await fetchCart();
    const path = buildCartPath(cart);
    return `${window.location.origin}${path}`;
  }

  function setMessage(root, text, isError = false) {
    const messageEl = root.querySelector(selectors.message);
    if (!messageEl) return;

    messageEl.hidden = !text;
    messageEl.textContent = text || '';
    messageEl.style.color = isError ? 'rgb(180, 40, 40)' : '';
  }

  async function copyToClipboard(text) {
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(text);
      return true;
    }

    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'absolute';
    textarea.style.left = '-9999px';
    document.body.appendChild(textarea);
    textarea.select();

    let success = false;
    try {
      success = document.execCommand('copy');
    } finally {
      textarea.remove();
    }

    if (!success) {
      throw new Error('Copy failed');
    }

    return true;
  }

  async function handleCopy(root) {
    try {
      setMessage(root, '');
      const url = await buildShareUrl();
      await copyToClipboard(url);
      setMessage(root, 'Link copied successfully.');
    } catch (error) {
      console.error(error);
      setMessage(root, 'Unable to copy the cart link.', true);
    }
  }

  async function handleWhatsApp(root) {
    try {
      setMessage(root, '');
      const url = await buildShareUrl();
      const text = `I wanted to share this cart with you: ${url}`;
      window.open(`https://wa.me/?text=${encodeURIComponent(text)}`, '_blank', 'noopener');
      setMessage(root, 'WhatsApp share opened.');
    } catch (error) {
      console.error(error);
      setMessage(root, 'Unable to prepare the WhatsApp share link.', true);
    }
  }

  async function handleEmail(root) {
    try {
      setMessage(root, '');
      const url = await buildShareUrl();
      const subject = 'Shared cart';
      const body = `I wanted to share this cart with you:\n\n${url}`;
      window.location.href = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
      setMessage(root, 'Email app opened.');
    } catch (error) {
      console.error(error);
      setMessage(root, 'Unable to prepare the email link.', true);
    }
  }

  function bindRoot(root) {
    if (!root || root.dataset.cartShareBound === 'true') return;
    root.dataset.cartShareBound = 'true';

    const copyBtn = root.querySelector(selectors.copy);
    const whatsappBtn = root.querySelector(selectors.whatsapp);
    const emailBtn = root.querySelector(selectors.email);

    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        handleCopy(root);
      });
    }

    if (whatsappBtn) {
      whatsappBtn.addEventListener('click', function () {
        handleWhatsApp(root);
      });
    }

    if (emailBtn) {
      emailBtn.addEventListener('click', function () {
        handleEmail(root);
      });
    }
  }

  function initCartShare() {
    document.querySelectorAll(selectors.root).forEach(bindRoot);
  }

  document.addEventListener('DOMContentLoaded', initCartShare);
  document.addEventListener('cart:updated', initCartShare);

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
      initCartShare();
    });
  }
})();